export default {
	label: '初级工程师',
	id: '0',
	children: [
		{
			label: '岗位定义',
			id: '0-1',
			children: [
				{
					label: '初级技术员是纺织制造业技术领域的入门级职位，通常负责基础性的工作任务，如设备维护、简单设计和数据分析等',
					id: '0-1-1',
				}
			]
		},
		{
			label: '设备技术员岗位职责',
			id: '0-2',
			children: [
				{
					label: '负责设备台账记录、设计图纸的规整、编制与存档',
					id: '0-2-1',
				},
				{
					label: '负责设备相关采购计划申报、跟进，到货验收工作',
					id: '0-2-2',
				},
				{
					label: '参与设备系统检修计划编制和相关具体工作',
					id: '0-2-3',
				},
				{
					label: '参与或负责现场设备故障判断',
					id: '0-2-4',
				},
				{
					label: '参与设备改造相关工作和设备安装调试与验收工作',
					id: '0-2-5',
				},
			],
		},
		{
			label: '电气技术员岗位职责',
			id: '0-3',
			children: [
				{
					label: '现场低压电气、仪器仪表的运行维护管理',
					id: '0-3-1',
				},
				{
					label: '安装和调试电气原件和自动化设备电路',
					id: '0-3-2',
				},
				{
					label: '自动化设备的组装和调试及维护',
					id: '0-3-3',
				},
				{
					label: '指导和培训设备使用部门人员，参与设备故障分析和事故调查',
					id: '0-3-4',
				},
				{
					label: '掌握紧急停电等应急预案、处置和解决生产用电问题，保障供配电系统稳定运行',
					id: '0-3-5',
				},
				{
					label: '贯彻执行上级有关设备专业技术、安全管理标准及公司各项规章制度',
					id: '0-3-6',
				},
			]
		},
		{
			label: '技能要求',
			id: '0-4',
			children: [
				{
					label: '机械类专业、电气工程、自动化、测控技术与仪器等专业',
					id: '0-4-1',
				},
				{
					label: '具备持续学习能力',
					id: '0-4-2',
				},
				{
					label: '熟练掌握电脑制图与办公软件',
					id: '0-4-3',
				}
			]
		}
	]
}